<template>
  <div
    class="star-rating-view"
  >
    <span
      class="stars"
      :style="{
        '--rating': rate,
        '--size': size,
      }"
    />
  </div>
</template>

<script>

export default {
  name: 'StarRatingView',
  props: {
    rate: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: '20px',
    },
  },
}
</script>

<style lang="scss" scoped>
$base-color: #D3D7E1;
$active-color: #FFA826;

.stars {
  font-size: var(--size);
  line-height: 1;
  font-family: Times; // make sure ★ appears correctly
  text-align: left;
  font-style: normal;
  display: inline-block;
  position: relative;
  unicode-bidi: bidi-override;

  &::before {
    display: block;
    content: '★★★★★';
    color: $base-color;
  }

  &::after {
    white-space: nowrap;
    position: absolute;
    top: 0;
    left: 0;
    content: '★★★★★';
    width: calc(var(--rating) * 20%);
    color: $active-color;
    overflow: hidden;
    height: 100%;
  }
}

</style>
